import {SocialPostPublishingAction} from '@Components/social-media/publish-params.types';
import {LoadingStates} from '@Utils/loading.util';

export enum PostPublishStatus {
  PUBLISHING = 'PUBLISHING',
  PUBLISHED = 'PUBLISHED',
  SCHEDULING = 'SCHEDULING',
  SCHEDULED = 'SCHEDULED',
  SAVING_DRAFT = 'SAVING_DRAFT',
  SAVED_DRAFT = 'SAVED_DRAFT',
  FAILED = 'FAILED',
}

export interface PostPublishStatusInput {
  publishingAction: SocialPostPublishingAction | undefined;
  loadingState: LoadingStates;
  publishErrorMessage: string | null;
}

const IN_FLIGHT_STATUS_BY_ACTION: Readonly<Record<SocialPostPublishingAction, PostPublishStatus>> = {
  [SocialPostPublishingAction.PUBLISH]: PostPublishStatus.PUBLISHING,
  [SocialPostPublishingAction.SCHEDULE]: PostPublishStatus.SCHEDULING,
  [SocialPostPublishingAction.SAVE]: PostPublishStatus.SAVING_DRAFT,
};

const SETTLED_STATUS_BY_ACTION: Readonly<Record<SocialPostPublishingAction, PostPublishStatus>> = {
  [SocialPostPublishingAction.PUBLISH]: PostPublishStatus.PUBLISHED,
  [SocialPostPublishingAction.SCHEDULE]: PostPublishStatus.SCHEDULED,
  [SocialPostPublishingAction.SAVE]: PostPublishStatus.SAVED_DRAFT,
};

const IN_FLIGHT_STATUSES: ReadonlySet<PostPublishStatus> = new Set([PostPublishStatus.PUBLISHING, PostPublishStatus.SCHEDULING, PostPublishStatus.SAVING_DRAFT]);

const hasSlotFailed = ({loadingState, publishErrorMessage}: PostPublishStatusInput): boolean => {
  return loadingState === LoadingStates.NOT_LOADED || (publishErrorMessage !== null && publishErrorMessage !== '');
};

/** An unset action means the publish screen mounted before the action was recorded, so it reads as publishing. */
export const getPostPublishStatus = (statusInput: PostPublishStatusInput): PostPublishStatus => {
  if (hasSlotFailed(statusInput)) {
    return PostPublishStatus.FAILED;
  }

  const {publishingAction, loadingState} = statusInput;

  if (publishingAction === undefined) {
    return PostPublishStatus.PUBLISHING;
  }

  if (loadingState === LoadingStates.LOADING) {
    return IN_FLIGHT_STATUS_BY_ACTION[publishingAction];
  }

  return SETTLED_STATUS_BY_ACTION[publishingAction];
};

export const isPostPublishStatusInFlight = (status: PostPublishStatus): boolean => {
  return IN_FLIGHT_STATUSES.has(status);
};
